import { Component, OnInit } from '@angular/core';
import { InvoiceTicketService } from 'src/app/services/invoice-ticket.service';
import { InvoiceTicket } from '../../../models/invoice-ticket';
import { UtilitiesService } from '../../../services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GasTravel } from '../../../models/gas-travel';
import * as _ from 'lodash';

@Component({
  selector: 'app-invoice-ticket',
  templateUrl: './invoice-ticket.component.html',
  styleUrls: ['./invoice-ticket.component.css']
})
export class InvoiceTicketComponent implements OnInit {

  loading: boolean = false;
  listInvoiceTicket: InvoiceTicket[] = [];
  listInvoiceTicketReal: InvoiceTicket[] = [];
  invoiceTicketSelected: InvoiceTicket = null;
  //Tickets Seleccionados que se van a quitar de una factura o se van a agregar a la factura
  ticketsAddRemoveInvoice: GasTravel[] = [];
  totalTicketMetric: number = 0;
  //Agregar Tickets Factura
  ticket: string = null;
  ticketsToGet: string[] = [];
  wereWanted: boolean = false; //Se establece en true si se realizo la busqueda de los tickets, revisar metodo searchSelectedTickets()
  //Tickets a asociar a Factura
  finalTicketsAssociateInvoice: GasTravel[] = [];
  //Paginacion
  p: number = 1;
  count: number = 25;

  constructor(private invoiceTicketService: InvoiceTicketService, private utl: UtilitiesService, private toastr: ToastrManager, private modalService: NgbModal) { }

  ngOnInit() {
    this.getInvoiceTickets();
  }

  getInvoiceTickets(){
    this.loading = true;
    this.invoiceTicketService.getInvoiceTicket().subscribe( response => {
      this.loading = false;
      this.listInvoiceTicket = response;
      this.listInvoiceTicketReal = _.filter(this.listInvoiceTicket, function(s){ return s.status != 'Cancelada' });
      this.listInvoiceTicket = this.listInvoiceTicketReal;
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  filterByParameters(event){
    if(event.target.value){
      let _invoice = String(event.target.value).trim();
      this.listInvoiceTicket = _.filter(this.listInvoiceTicketReal, function(s){
        return _.startsWith(s.invoice_number, _invoice);
      });
    }else{
      this.listInvoiceTicket = this.listInvoiceTicketReal;
    }
  }

  removeInvoiceTicketModal(modal, _invoiceTicketSelected: InvoiceTicket){
    this.invoiceTicketSelected = _invoiceTicketSelected;
    this.totalTicketMetric = _.sumBy(this.invoiceTicketSelected.gastickets, m => Number(m.metric_real));
    this.modalService.open(modal, {size: 'lg'});
  }

  selectedTickets(_ticket: GasTravel){
    if(this.ticketsAddRemoveInvoice.includes(_ticket)){
      let index = this.ticketsAddRemoveInvoice.indexOf(_ticket);
      if(index !== -1){
        this.ticketsAddRemoveInvoice.splice(index, 1);
      }

    }else{
      this.ticketsAddRemoveInvoice.push(_ticket);
    }
  }

  updateInvoiceTicketModal(modal, id){
    this.invoiceTicketSelected = null;
    this.invoiceTicketSelected = _.find(this.listInvoiceTicketReal, (t) => t.id == id);
    this.modalService.open(modal, {size: 'lg'});
  }

  /*Actualizar Datos Factura*/
  updateDataInvoiceTicket(){
    this.loading = true;
    this.invoiceTicketService.updateDataInvoiceTickets(this.invoiceTicketSelected).subscribe( response => {
      this.loading = false;
      this.listInvoiceTicket = response;
      this.listInvoiceTicketReal = _.filter(this.listInvoiceTicket, function(s){ return s.status != 'Cancelada' });
      this.listInvoiceTicket = this.listInvoiceTicketReal;
      this.modalService.dismissAll();
      this.toastr.successToastr("La factura " + this.invoiceTicketSelected.invoice_number + " se actualizó correctamente", '', {enableHTML:true});
      this.setDefualtValues();
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error) + " " + this.invoiceTicketSelected.invoice_number, '', {enableHTML:true});
    });
  }

  getInvoiceTotal(event){
    if(event.target.value)
      this.invoiceTicketSelected.total = ((Number(this.invoiceTicketSelected.subtotal) * Number(this.invoiceTicketSelected.iva)) + Number(this.invoiceTicketSelected.subtotal));
    else
      this.invoiceTicketSelected.total = 0;
  }

  addInvoiceTicketModal(modal, _invoice: InvoiceTicket){
    this.setDefualtValues();
    this.invoiceTicketSelected = _invoice;
    this.modalService.open(modal, {size: 'lg'});
  }

  /* Eliminar los tickets asociados a una factura */
  removeInvoiceAssociatedTickets(){
    this.loading = true;
    this.invoiceTicketService.removeInvoiceTickets(this.ticketsAddRemoveInvoice, this.invoiceTicketSelected).subscribe( response => {
      this.loading = false;
      this.listInvoiceTicket = response;
      this.listInvoiceTicketReal = _.filter(this.listInvoiceTicket, function(s){ return s.status != 'Cancelada' });
      this.listInvoiceTicket = this.listInvoiceTicketReal;
      this.modalService.dismissAll();
      this.toastr.successToastr("Los tickets fueron removidos de la factura " + this.invoiceTicketSelected.invoice_number + " correctamente", '', {enableHTML:true});
      this.setDefualtValues();
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error) + " " + this.invoiceTicketSelected.invoice_number, '', {enableHTML:true});
    });
  }

  addTicketToSearch(){
    if(this.ticket){
      if(!this.ticketsToGet.includes(this.ticket)){
        this.ticketsToGet.push(this.ticket);
        this.ticket = null;
      }else{
        this.toastr.infoToastr("Este ticket " + this.ticket + " ya esta en la lista de búsqueda", '', {enableHTML:true});
        this.ticket = null;
      }
    }else{
      this.toastr.infoToastr("Por favor ingresa un ticket válido", '', {enableHTML:true});
    }
  }

  deleteTicketToSearch(ticket: string){
    if(this.ticketsToGet.includes(ticket)){
      let index = this.ticketsToGet.indexOf(ticket);
      if(index !== -1){
        this.ticketsToGet.splice(index, 1);
        this.toastr.successToastr("Ticket " + this.ticket + " quitado de la lista de búsqueda correctamente", '', {enableHTML:true});
        this.ticket = null;
      }
    }
  }

  /*Busca los tickets agregados a ls busqueda por el usuario*/
  searchSelectedTickets(){
    this.loading = true;
    this.invoiceTicketService.getSelectedTickets(this.ticketsToGet).subscribe( response => {
      this.loading = false;
      this.ticketsAddRemoveInvoice = response;
      this.wereWanted = true;
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML:true});
    });
  }

  addTicketsFinalSelection(_ticket: GasTravel){
    //Si esta en la lista de obtenidos se agrega a la lista final
    if(this.ticketsAddRemoveInvoice.includes(_ticket) && !this.finalTicketsAssociateInvoice.includes(_ticket)){
      this.finalTicketsAssociateInvoice.push(_ticket);
    }else{
      let index = this.finalTicketsAssociateInvoice.indexOf(_ticket);
      if(index !== -1){
        this.finalTicketsAssociateInvoice.splice(index, 1);
        this.toastr.infoToastr("El ticket " + _ticket.gasticket + " fue desasociado de la factura", '', {enableHTML:true});
      }
    }
  }

  associateTicketsToInvoice(){
    this.loading = true;
    this.invoiceTicketService.associateTicketsToInvoices(this.finalTicketsAssociateInvoice, this.invoiceTicketSelected).subscribe( response => {
      this.loading = false;
      this.listInvoiceTicket = response;
      this.listInvoiceTicketReal = _.filter(this.listInvoiceTicket, function(s){ return s.status != 'Cancelada' });
      this.listInvoiceTicket = this.listInvoiceTicketReal;
      this.modalService.dismissAll();
      this.toastr.successToastr("Los tickets fueron asociados a la factura " + this.invoiceTicketSelected.invoice_number + " correctamente", '', {enableHTML:true});
      this.setDefualtValues();
    }, error => {
      this.loading = false;
      this.modalService.dismissAll();
      this.toastr.errorToastr(this.utl.formatMessages(error)  + " " + this.invoiceTicketSelected.invoice_number + ". Puede volver a intentar o contactar a la parte de soporte de la plataforma.", '', {enableHTML:true});
    });
  }

  cancelInvoiceTicketModal(modal, _invoiceTicketSelected: InvoiceTicket){
    this.invoiceTicketSelected = _invoiceTicketSelected;
    this.modalService.open(modal, {size: 'lg'});
  }

  cancelInvoiceTicket(){
    this.loading = true;
    this.invoiceTicketService.cancelInvoiceTickets(this.invoiceTicketSelected).subscribe( response => {
      this.loading = false;
      this.listInvoiceTicket = response;
      this.listInvoiceTicketReal = _.filter(this.listInvoiceTicket, function(s){ return s.status != 'Cancelada' });
      this.listInvoiceTicket = this.listInvoiceTicketReal;
      this.modalService.dismissAll();
      this.toastr.successToastr("La factura "  + this.invoiceTicketSelected.invoice_number + " fue eliminada correctamente", '', {enableHTML:true});
      this.setDefualtValues();
    }, error => {
      this.loading = false;
      this.modalService.dismissAll();
      this.toastr.errorToastr(this.utl.formatMessages(error) + " " + this.invoiceTicketSelected.invoice_number, '', {enableHTML:true});
    });
  }

  setDefualtValues(){
    this.ticket = null;
    this.ticketsToGet = [];
    this.wereWanted = false;
    this.ticketsAddRemoveInvoice = [];
    this.finalTicketsAssociateInvoice = [];
    this.totalTicketMetric = 0;
    this.invoiceTicketSelected = null;
  }
}
